import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'

import { updatePin } from '../../actions/pins'
import { loadHistoriesForPin } from '../../actions/histories'

import imageToDataURI from '../../helpers/imageToDataURI'

import PinForm from '../../components/pins/pin-form'

const fields = [
  'beforeImage',
  'afterImage',
  'status',
  'description'
]

function mapStateToProps (state, ownProps) {
  const pin = state.pins[ownProps.params.pinId]

  var beforeImage = null
  var afterImage = null
  if (pin.beforeImage && pin.beforeImage.url) {
    beforeImage = {
      preview: pin.beforeImage.url
    }
  }
  if (pin.afterImage && pin.afterImage.url) {
    afterImage = {
      preview: pin.afterImage.url
    }
  }

  return {
    modalTitle: 'Update Pin',
    updating: true,
    initialValues: {
      ...pin,
      beforeImage,
      afterImage
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(updatePin(ownProps.params.pinId, data))
        .then(() => dispatch(loadHistoriesForPin(ownProps.params.pinId, false, true)))
        .then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'updatePin'
  },
  mapStateToProps,
  mapDispatchToProps
)(PinForm)



// WEBPACK FOOTER //
// ./src/containers/pins/update-pin-container.js